<template>
	<v-card elevation="0">
		<v-card-title>报表参数编辑</v-card-title>
		<v-card-text>
			<v-row class="ma-0 pa-0">
				<v-col cols="12">
					<v-text-field
						label="显示名称*"
						name="label"
						placeholder=""
						v-model="form.label"
						:error-messages="errors.label"
						required
					></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-text-field
						label="参数名（在SQL中的名字）*"
						name="name"
						v-model="form.name"
						hint=""
						:error-messages="errors.name"
						required
					></v-text-field>
				</v-col>
				<v-col cols="4">
					<v-select
						:items="refs['ParameterType']"
						v-model="form.type"
						label="类型"
						auto
						required
						item-text="text"
						item-value="value"
					></v-select>
				</v-col>
				<v-col cols="6">
					<v-text-field
						label="排序值"
						type="number"
						v-model="form.sort"
						hint="默认排序值越大越靠后"
						persistent-hint
					></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-text-field
						label="默认值"
						v-model="form.defaultValue"
						persistent-hint
						hint="例如：date('-0 days','Y-m-01 00:00:00') 当月第一天"
					></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-subheader>备注</v-subheader>
					<v-textarea v-model="form.description" rows="2" outlined></v-textarea>
					<template v-if="['select', 'multiselect'].includes(form.type)">
						格式：value:label,value:label...，如 female:女,male:男，或者直接：female,male
					</template>
				</v-col>
			</v-row>
		</v-card-text>
		<slot name="actions" v-bind:object="form"></slot>
	</v-card>
</template>

<script>
import { clone } from 'lodash-es'

export default {
	components: {},
	emits: ['update:value'],

	props: {
		value: { type: Object, default: null },
		errors: { type: Object, default: () => ({}) }
	},
	data: () => ({
		form: {},
		refs: {}
	}),
	computed: {},
	watch: {
		form: {
			handler: function (nv, oldVal) {
				if (nv) {
					this.$emit('update:value', this.form)
				}
			},
			deep: true
		}
	},
	mounted() {
		this.form = clone(this.value)
		this.$api.common.getMeta('report', 'ParameterType,ParameterStatus', (r) => {
			this.refs = r
		})
	},
	methods: {
		addColumn() {
			this.form.columns.push({})
		},
		clear() {
			this.form = {}
		},
		addParameter() {
			this.form.parameters.push({})
		}
	}
}
</script>
<style></style>
